// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2s0b_","comment":"styles_comment__10Jhu"};